import { useUpsertEHRNotesMutation } from "app/store/transmission/api/transmissionDetailApi";
import {
  changeExpansion,
  onEHRNoteChange,
  toggleSubmitting,
  loadEHRNoteList,
  selectedReport,
  setCanEditEHRNote,
} from "app/store/transmission/slice/transmissionSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CLINIC_ROLES, USER_ROLES } from "static/constants";
import { getCurrentUserRole } from "utils/currentUser.util";
import { showErrorToast, showSuccessToast } from "utils/toast";

const useEHRNotes = (data) => {
  const {
    reportDetail,
    ehrNoteList,
    canEditEHRNote,
    isLegacyReport,
    currentEhrNote,
    ehrNoteFocused,
    ehrNoteExpanded,
    ehrNoteSubmitting,
  } = useSelector((state) => state.transmission);
  const { isArchiveReport } = useSelector((state) => state.archiveReport);

  const dispatch = useDispatch();

  const [upsertEHRNotes] = useUpsertEHRNotesMutation();

  useEffect(() => {
    const userRole = getCurrentUserRole();

    const accessedRoles = [USER_ROLES.ADMIN, USER_ROLES.USER, ...CLINIC_ROLES];

    const canEdit =
      accessedRoles.includes(userRole) && !isArchiveReport && !data?.legacy;

    dispatch(setCanEditEHRNote(canEdit));
  }, []);

  const handleEHRNote = async () => {
    try {
      dispatch(toggleSubmitting({ type: "ehrNotes", value: true }));

      const { _id: note_id, note } = currentEhrNote || {};

      const payload = note_id ? { note_id, note } : { note };

      const result = await upsertEHRNotes({
        reportId: data?._id,
        payload,
      }).unwrap();

      if (result?.data) {
        const ehrNotes = result?.data?.ehr_notes;
        dispatch(loadEHRNoteList(ehrNotes));
        dispatch(
          selectedReport({
            id: data?._id,
            isLegacyReport: isLegacyReport,
            reportDetail: { ...reportDetail, ehr_notes: ehrNotes },
          })
        );
        dispatch(onEHRNoteChange({}));
        showSuccessToast(result?.message);
      }
    } catch (error) {
      showErrorToast(error?.data?.message || error?.message);
    } finally {
      dispatch(toggleSubmitting({ type: "ehrNotes", value: false }));
    }
  };

  const handleEdit = (selectedEHRNote) => {
    dispatch(onEHRNoteChange({ ...selectedEHRNote }));
    dispatch(changeExpansion({ type: "ehrNotes", value: true }));
  };

  return {
    dispatch,
    handleEdit,
    ehrNoteList,
    handleEHRNote,
    canEditEHRNote,
    currentEhrNote,
    ehrNoteFocused,
    ehrNoteExpanded,
    ehrNoteSubmitting,
  };
};

export default useEHRNotes;
